// import Swiper JS
import Swiper, {Autoplay} from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay]);

const gallerySlider = new Swiper('#tm-gallery-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
        639: {
            slidesPerView: 2
        },
        1199: {
            slidesPerView: 3,
        },
    },
    autoplay: {
        delay: 4000,
        waitForTransition: false,
        disableOnInteraction: false
    },
})
